export default class PersonSearchResponse {
  candidateList: any[];
  totalCandidatesCount: number;
  talentdiscoveryhistoryid: string;
  totalresultscount: number;
  booleanquery: string;
  message: string;

  constructor() {
    this.candidateList = [];
    this.totalCandidatesCount = 0;
    this.talentdiscoveryhistoryid = "";
    this.totalresultscount = 0;
    this.booleanquery = "";
    this.message = "";
  }
}
